// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"0126c0a4c86fdb9a436f","595":"a2d6ef84272188904b2c"}[chunkId] + ".js";
};